import { render, staticRenderFns } from "./SpdRecord.vue?vue&type=template&id=032e4b7d&"
import script from "./SpdRecord.vue?vue&type=script&lang=js&"
export * from "./SpdRecord.vue?vue&type=script&lang=js&"
import style0 from "./SpdRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports